export default __webpack_public_path__ + "locales/it/Common.json?hash=fec382068a9bdf9117b28a6ef0bc7f13";